import * as React from 'react';

import { VisuallyHidden } from '@coursera/cds-core';

import type { Item } from 'bundles/learner-progress/types/Item';
import { getFormattedTitlePrefix, getFormattedTitlePrefixForA11y } from 'bundles/learner-progress/utils/Item';
import { useCourseAiGradingContext } from 'bundles/peer/components/ai-grading/CourseAiEligibilityProvider';

type Props = {
  computedItem: Item;
  isGuidedProject?: boolean;
  isVerifiedSkillsCourse?: boolean;
};

export const NavItemName = ({ computedItem, isGuidedProject, isVerifiedSkillsCourse }: Props) => {
  const { getItemAiGradingEligibility } = useCourseAiGradingContext();
  const isAiGradingEligible = getItemAiGradingEligibility(computedItem.id);

  const formattedTitlePrefix = getFormattedTitlePrefix(
    computedItem,
    isGuidedProject,
    isAiGradingEligible,
    isVerifiedSkillsCourse
  );
  const formattedTitlePrefixForA11y = getFormattedTitlePrefixForA11y(computedItem, isGuidedProject);

  return (
    // TODO: Switch to coursera-ui instead of using a semantically questionable className
    <div className="rc-NavItemName caption-text">
      {!!formattedTitlePrefix && <strong>{`${formattedTitlePrefix}: `}</strong>}

      {!!formattedTitlePrefixForA11y && (
        <VisuallyHidden component="span" className="rc-A11yScreenReaderOnly">
          {formattedTitlePrefixForA11y}
        </VisuallyHidden>
      )}

      {computedItem.name}
    </div>
  );
};

export default NavItemName;
